import { Scene, DirectionalLight } from 'three'

const LIGHT_SETTINGS = {
  SHADOW: {
    POSITION: {
      X: -1,
      Y: 1,
      Z: 6,
    },
    NEAR: 0,
    FAR: 7,
    EXTENTS: 8,
    RESOLUTION: 1024,
    BIAS: 0,
    RADIUS: 1,
  },
} as const

export const initializeLight = (scene: Scene) => {
  const light = new DirectionalLight('white', 1)
  light.name = 'MainLight'
  light.position.set(
    LIGHT_SETTINGS.SHADOW.POSITION.X,
    LIGHT_SETTINGS.SHADOW.POSITION.Y,
    LIGHT_SETTINGS.SHADOW.POSITION.Z
  )

  light.castShadow = true
  light.shadow.camera.near = LIGHT_SETTINGS.SHADOW.NEAR
  light.shadow.camera.far = LIGHT_SETTINGS.SHADOW.FAR
  light.shadow.camera.right = LIGHT_SETTINGS.SHADOW.EXTENTS
  light.shadow.camera.left = -LIGHT_SETTINGS.SHADOW.EXTENTS
  light.shadow.camera.top = LIGHT_SETTINGS.SHADOW.EXTENTS
  light.shadow.camera.bottom = -LIGHT_SETTINGS.SHADOW.EXTENTS
  light.shadow.mapSize.width = LIGHT_SETTINGS.SHADOW.RESOLUTION
  light.shadow.mapSize.height = LIGHT_SETTINGS.SHADOW.RESOLUTION
  light.shadow.bias = LIGHT_SETTINGS.SHADOW.BIAS
  light.shadow.radius = LIGHT_SETTINGS.SHADOW.RADIUS
  light.intensity = 0.7

  scene.add(light)

  return light
}
